
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { NgbModal, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { UserService } from '@services/core/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-user-roles',
  templateUrl: './roles.component.html',
  styleUrls: ["./roles.component.scss"],
  imports: [PanelComponent, FormsModule, ReactiveFormsModule],
  providers: [UserService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class UserRolesComponent implements OnInit {

  private _userService = inject(UserService)
  private _fb = inject(FormBuilder)
  private _modalService = inject(NgbModal)
  private destroyRef = inject(DestroyRef)
  protected roles
  protected search = ""

  private modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: null
  }
  public closeResult = ""
  protected newRoleForm = this._fb.group({
    id: [null],
    name: ["", Validators.required],
    description: ["", Validators.required],
    enabled: [true],
  })

  ngOnInit(): void {
    this.getRoles();
  }

  open(modal, role?) {
    if(role) this.newRoleForm.patchValue(role)
    this._modalService.open(modal, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  getRoles() {
    this._userService.getRoles().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((roles) => {
      this.roles = roles;
    });
  }

  saveRole() {
    this._userService.updateRole(this.newRoleForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
      this.roles = response
      this.newRoleForm.reset();
      this.newRoleForm.patchValue({enabled: true})
    });
  }

  enabledRole(role){
    role.enabled = !role.enabled
    this._userService.updateRole(role).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
      this.roles = response
    });
  }

} 
